import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

function loadNewRelic(config: any) {
  if (environment.production) {
    const script = document.createElement('script');
    script.innerHTML = `
    window.NREUM ||= {};
    NREUM.init = { distributed_tracing: { enabled: true }, privacy: { cookies_enabled: true }, ajax: { deny_list: ["bam.nr-data.net"] } };
    NREUM.loader_config = {
      accountID: "${config.accountID}",
      trustKey: "${config.trustKey}",
      agentID: "${config.agentID}",
      licenseKey: "${config.licenseKey}",
      applicationID: "${config.applicationID}"
    };
    NREUM.info = {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: "${config.licenseKey}",
      applicationID: "${config.applicationID}",
      sa: 1
    };
    (function() {
      var e = document.createElement("script");
      e.src = "https://js-agent.newrelic.com/nr-loader-spa-1.292.0.min.js";
      e.async = true;
      document.head.appendChild(e);
    })();
  `;
    document.head.appendChild(script);
  }
}

loadNewRelic(environment.newRelic);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

if (environment.production) {
  if (window) {
    window.console.log = function () { };
    window.console.error = function () { };
    window.console.warn = function () { };
  }
}
